export const isEmptyArr = (arr: Array<unknown> | null | undefined): boolean => {
  if (!arr) return true;

  return arr?.length === 0;
};
